import LocaleSelector from '@components/inputs/locale-selector'
import SocialLinks from '@components/social-links'

import styles from './footer.module.scss'

export default function Footer({ close }: { close: () => void }): JSX.Element {
  return (
    <div className={styles.footer}>
      <div className={styles['country-selector']}>
        <h3>Looking for jobs in</h3>
        <LocaleSelector text="" callback={close} className={styles.selector} />
      </div>
      <div className={styles.social}>
        <h3>Follow us</h3>
        <SocialLinks theme="dark" />
      </div>
    </div>
  )
}
